export default {
    january: "Januar",
    february: "Februar",
    march: "Mart",
    april: "April",
    may: "Maj",
    june: "Jun",
    july: "Jul",
    august: "Avgust",
    september: "Septembar",
    october: "Oktobar",
    november: "Novembar",
    december: "Decembar"
}
